var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "modal modal-fullscreen modal-filter-details fade",
      attrs: {
        id: "modal-add-talent",
        role: "dialog",
        "aria-labelledby": "shortlist-modal-label",
        "aria-hidden": "true",
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "modal-dialog",
          attrs: { "data-backdrop": "true", "data-keyboard": "true" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h4",
                {
                  staticClass: "modal-title",
                  attrs: { id: "shortlist-modal-label" },
                },
                [
                  _vm.$userIsAdmin
                    ? [
                        _vm._v(
                          "Add " +
                            _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                        ),
                      ]
                    : _vm.$userIsManager
                    ? [
                        _vm._v(
                          "Apply For " +
                            _vm._s(_vm._f("sentenceCase")(_vm.$starLabelPlural))
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _vm.visible
                  ? _c("talent-filtering", {
                      attrs: {
                        "existing-talent": this.booking.talent,
                        "scroll-target": "#modal-add-talent .modal-body",
                        "booking-budget": this.booking.budget_per_star,
                        booking: this.booking,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-lg btn-danger pull-left",
                    attrs: { type: "button", "data-dismiss": "modal" },
                    on: { click: _vm.handleModalClose },
                  },
                  [_c("i", { staticClass: "fa fa-close" }), _vm._v(" Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "ladda-button",
                  {
                    staticClass: "btn btn-lg btn-primary",
                    attrs: {
                      type: "button",
                      click: _vm.handleSaveAdditionalTalentCallback,
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-check" }),
                    _vm._v(" Save\n        "),
                  ]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }